import { displayLabel } from "../../utils/displayLabel";
import { useEffect } from "react";

const SEOHead = ({ title, description, image, url }) => {
  useEffect(() => {
    if (title) {
      document.title = displayLabel(title);
      setMeta("og:title", displayLabel(title));
      setMeta("twitter:title", displayLabel(title));
    }
    if (description) {
      setMeta("description", description);
      setMeta("og:description", description);
      setMeta("twitter:description", description);
    }
    if (image) {
      setMeta("og:image", image);
      setMeta("twitter:image", image);
    }
    if (url) {
      setMeta("og:url", url);
    }
  }, [title, description, image, url]);

  return null;
};

function setMeta(name, content) {
  const isOg = name.startsWith("og:");
  const attr = isOg ? "property" : "name";
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default SEOHead;
